// BlueMonk shared constants
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/bluemonk`;

export const BRAND_COLORS = {
  'renew-circuits': { bg: 'bg-blue-50', border: 'border-l-[#1A73E8]', text: 'text-[#1A73E8]', badge: 'bg-[#1A73E8]' },
  'bluemonk-group': { bg: 'bg-green-50', border: 'border-l-[#34A853]', text: 'text-[#34A853]', badge: 'bg-[#34A853]' },
  'deshwal': { bg: 'bg-amber-50', border: 'border-l-[#F9AB00]', text: 'text-[#F9AB00]', badge: 'bg-[#F9AB00]' },
  'all': { bg: 'bg-slate-50', border: 'border-l-slate-400', text: 'text-slate-600', badge: 'bg-slate-500' },
};

export const BRAND_LABELS = {
  'renew-circuits': 'RC',
  'bluemonk-group': 'BM',
  'deshwal': 'DW',
  'all': 'ALL',
};

export { BACKEND_URL };
